import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { useMerchantPolicySettings } from '../../hooks/useMerchantPolicySettings';
import { useMerchantTermsOfServiceMessage } from '../../hooks/useMerchantTermsOfServiceMessage';
import MaybeCancellationAndRefundPolicies from './MaybeCancellationAndRefundPolicies';
import TermsOfService from './TermsOfService';
import { getIsZeroCheckoutValid } from '../../utils/validations';
import PaymentMethodOnFile from '../PaymentMethodOnFile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MaybeMerchantTermsAndConditions = () => {
  const {
    checkoutSession: checkoutSessionMap
  } = usePaymentFormContext();
  const checkoutSession = checkoutSessionMap.toJS();
  const {
    policySettings
  } = useMerchantPolicySettings(checkoutSession);
  const translationMessageKey = useMerchantTermsOfServiceMessage();
  const collectPaymentMethodOnFile = checkoutSession.collectPaymentMethodOnFile;
  const isZeroCheckout = getIsZeroCheckoutValid(checkoutSession.subtotalsPublicResponse && checkoutSession.subtotalsPublicResponse.paymentAmount, checkoutSession.lineItems);
  if (!isZeroCheckout && (!policySettings || !translationMessageKey) && !collectPaymentMethodOnFile) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "merchant-terms-and-conditions",
    children: [/*#__PURE__*/_jsx(TermsOfService, {
      translationMessageKey: translationMessageKey,
      isZeroCheckout: isZeroCheckout
    }), policySettings && /*#__PURE__*/_jsx(MaybeCancellationAndRefundPolicies, {
      policySettings: policySettings
    }), collectPaymentMethodOnFile && /*#__PURE__*/_jsx(PaymentMethodOnFile, {
      checkoutSession: checkoutSession
    })]
  });
};
export default MaybeMerchantTermsAndConditions;